import styled from 'styled-components'

import { ImageCustom } from '@/components/shared/image'
import { LinkCustom } from '@/components/shared/link-custom/LinkCustom'
import { MEDIA_QUERIES } from '@/ui/constants/mediaQueries'

const MAX_TILE_WIDTH = '14.4rem'
const MIN_TILE_WIDTH = '12.6rem'

export const BodyTypeTileContainer = styled.div(
  ({ theme }) =>
    `
  width: fit-content;
  &:hover {
    p {
      color: ${theme.colors.purple.primary};
    }
  }
`
)

export const BodyTypeTileImageContainer = styled.div(
  ({ theme }) => `
  background-color: #F3F3F3;
  border-radius: ${theme.borderRadius.large}; 
  border: 0.1rem solid transparent;
  width: ${MIN_TILE_WIDTH};
  height: 9.4rem;

  &:hover {
    border-color: ${theme.colors.purple.light4};
    box-shadow: 0.2rem 0.2rem 0.4rem 0 #3E41531A;
  }
  &:focus {
    border-color: ${theme.colors.blue.primary};   
  }

  ${MEDIA_QUERIES(theme).medium} {
    width: ${MAX_TILE_WIDTH};
  }
  `
)

export const BodyTypeTileImage = styled(ImageCustom)`
  width: 100%;
  height: 100%;
  object-fit: cover;
`

export const CategoryTileContainer = styled.div(
  ({ theme }) =>
    `
  border-radius: ${theme.borderRadius.medium};
  background: ${theme.colors.purple.dark1};

  &:hover {
    background: ${theme.colors.grey.light4};
    p {
     color: ${theme.colors.purple.primary}
    }
    p:nth-child(2) {
      color: ${theme.colors.purple.light2};
    }
  }
`
)

export const CategoryTileImage = styled(ImageCustom)(
  ({ theme }) =>
    `
  max-width: 100%; 
  width: 100%;  
  height: 20rem;
  object-fit: cover;
  border-top-left-radius: ${theme.borderRadius.medium};
  border-top-right-radius: ${theme.borderRadius.medium};
`
)

export const MaintainProtectLayoutWrapper = styled.div(
  ({ theme }) =>
    `
  padding-bottom: ${theme.spacing.xLarge};
  margin-top: ${theme.spacing.mini};
  margin-bottom: ${theme.spacing.default};
  border-bottom: 0.1rem solid ${theme.colors.grey.light4};
  `
)

export const MaintainProtectTileContainer = styled.div(
  ({ theme }) =>
    `
  border-radius: ${theme.borderRadius.large};
  background: ${theme.colors.purple.light5};
  display: flex;
  align-items: center;
  padding: 1.6rem;
  color: ${theme.colors.grey.primary};
  border: 0.1rem solid transparent;

  &:hover {
    color: ${theme.colors.purple.primary};
    border-color: ${theme.colors.purple.light4};
    box-shadow: 0.2rem 0.2rem 0.4rem 0 #3E41531A;
  }
`
)

export const MaintainProtectImage = styled(ImageCustom)`
  border-radius: 50%;
  height: 10rem;
  width: 10rem;
  object-fit: cover;
`

export const MaintainProtectLink = styled(LinkCustom)`
  display: block;
  width: 100%;
`
